module.exports = __webpack_public_path__ + "static/media/iphone-x-outdoor-bench-generating-setlist-dark-resized.360e486e.jpg";